import {
  GET_BATTLEFIELD_SUCCESS,
  GET_MY_BATTLEFIELD_SUCCESS,
  GET_BATTLEFIELD_FAIL,
  GET_SPEC_BATTLEFIELD_SUCCESS,
  GET_SPEC_BATTLEFIELD_FAIL,
  ADD_BATTLEFIELD_SUCCESS,
  ADD_BATTLEFIELD_FAIL,
  UPDATE_BATTLEFIELD_SUCCESS,
  UPDATE_BATTLEFIELD_FAIL,
  DELETE_BATTLEFIELD_SUCCESS,
  DELETE_BATTLEFIELD_FAIL,
  UPDATE_PERIOD_SUCCESS,
  UPDATE_PERIOD_FAIL,
  SHOW_LOADING,
  HIDE_LOADING
} from './actionTypes';

const INIT_STATE = {
  my_battles: [],
  battles: [],
  filtered_battles: [],
  managers: [],
  date: [],
  years: [],
  months: [],
  tr_agents: [],
  wh_managers_uk: [],
  success: null,
  error: null,
  loading: true
};

const battles = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_BATTLEFIELD_SUCCESS:
      return {
        ...state,
        date: action.payload[0],
        managers: action.payload[1],
        battles: action.payload[2],
        years: action.payload[3],
        months: action.payload[4],
        tr_agents: action.payload[5],
        wh_managers_uk: action.payload[6],
        my_battles: []
      };
    case GET_MY_BATTLEFIELD_SUCCESS:
      return {
        ...state,
        date: action.payload[0],
        managers: action.payload[1],
        my_battles: action.payload[2],
        years: action.payload[3],
        months: action.payload[4],
        tr_agents: action.payload[5],
        wh_managers_uk: action.payload[6],
        battles: []
      };
    case GET_BATTLEFIELD_FAIL:
      return {
        ...state,
        error: action.payload
      };

    case GET_SPEC_BATTLEFIELD_SUCCESS:
      return {
        ...state,
        filtered_battles: action.payload
      };
    case GET_SPEC_BATTLEFIELD_FAIL:
      return {
        ...state,
        error: action.payload
      };

    case ADD_BATTLEFIELD_SUCCESS:
      return {
        ...state,
        battles: state.battles.length === 0 ? state.battles : [...state.battles, action.payload[0]],
        my_battles: state.battles.length === 0 ? [...state.my_battles, action.payload[0]] : state.my_battles,
        // battles: [...state.battles, action.payload[0]],
        success: { data: 'success' }
      };
    case ADD_BATTLEFIELD_FAIL:
      return {
        ...state,
        error: action.payload
      };

    case UPDATE_BATTLEFIELD_SUCCESS:
      return {
        ...state,
        battles:
          state.battles.length === 0
            ? state.battles
            : state.battles.map((service) => {
                const match = action.payload.find((item) => item._id.toString() === service._id.toString());
                return match ? { ...service, ...match } : service;
              }),
        my_battles:
          state.battles.length === 0
            ? state.my_battles.map((service) => {
                const match = action.payload.find((item) => item._id.toString() === service._id.toString());
                return match ? { ...service, ...match } : service;
              })
            : state.my_battles,

        // battles: state.battles.map(service => {
        //   const match = action.payload.find(item => item._id.toString() === service._id.toString());
        //   return match ? { ...service, ...match } : service;
        // }),
        filtered_battles: state.filtered_battles.map((service) => {
          const match = action.payload.find((item) => item._id.toString() === service._id.toString());
          return match ? { ...service, ...match } : service;
        }),
        success: { data: 'success' }
      };
    case UPDATE_BATTLEFIELD_FAIL:
      return {
        ...state,
        error: action.payload
      };

    case DELETE_BATTLEFIELD_SUCCESS:
      return {
        ...state,
        battles:
          state.battles.length === 0
            ? state.battles
            : state.battles.filter((service) => {
                return !action.payload.includes(service._id.toString());
              }),
        my_battles:
          state.battles.length === 0
            ? state.my_battles.filter((service) => {
                return !action.payload.includes(service._id.toString());
              })
            : state.my_battles
        // battles: state.battles.filter(service => { return !action.payload.includes(service._id.toString()); }),
      };
    case DELETE_BATTLEFIELD_FAIL:
      return {
        ...state,
        error: action.payload
      };

    case UPDATE_PERIOD_SUCCESS:
      return {
        ...state,
        date: action.payload,
        success: { data: 'success' }
      };
    case UPDATE_PERIOD_FAIL:
      return {
        ...state,
        error: action.payload
      };

    case SHOW_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    case HIDE_LOADING:
      return {
        ...state,
        loading: action.payload
      };

    default:
      return state;
  }
};

export default battles;
